// src/pages/ForgotPassword.js
import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleReset = async (e) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('Check your inbox for further instructions.');
      setError('');
    } catch (err) {
      setError('Failed to reset password. ' + err.message);
      setMessage('');
    }
  };

  return (
    <div className="container" style={{ padding: '100px 20px', maxWidth: '500px' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Reset Password</h2>
      
      {error && (
        <div style={{ backgroundColor: '#f8d7da', color: '#721c24', padding: '10px', borderRadius: '5px', marginBottom: '15px' }}>
          {error}
        </div>
      )}
      
      {message && (
        <div style={{ backgroundColor: '#d4edda', color: '#155724', padding: '10px', borderRadius: '5px', marginBottom: '15px' }}>
          {message}
        </div>
      )}

      <form onSubmit={handleReset} style={{ border: '1px solid #ddd', padding: '30px', borderRadius: '8px', background: 'white' }}>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div>

        <button 
          type="submit" 
          className="btn btn-primary"
          style={{ width: '100%', padding: '12px', fontSize: '1rem' }}
        >
          Reset Password
        </button>
      </form>
      <div style={{marginTop: '20px', textAlign: 'center'}}>
        <Link to="/login" style={{color: 'var(--accent-blue)'}}>Back to Login</Link>
      </div>
    </div>
  );
};

export default ForgotPassword;